<template>
  <div :id="id" class="modal fade" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-pdf">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">{{ $t("global.importfile") }}</h4>
        </div>
        <div class="modal-body">
          <div class="col-xl-12">
            <div class="form-group text-center">
              <vue-2-dropzone
                id="dropzone"
                ref="dokumenteUpload"
                class="
                  dropzone-white dropzone-small
                  vue-dropzone
                  dropzone
                  dz-clickable
                "
                :options="dropzoneOptions"
                @vdropzone-success="fileUploaded"
              ></vue-2-dropzone>
              <button class="btn btn-primary mt-2" @click="uploadFiles">
                {{ $t("global.upload") }}
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="close">
            {{ $t("global.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import store from "@/store";
import Api from "@/Api";
import vue2Dropzone from "vue2-dropzone";
import { dropzoneOptionsBild } from "@/config/Dropzone";
import ModalCloseButton from "@/components/global/ModalCloseButton.vue";

export default {
  name: "FileUploadModal",
  components: {
    vue2Dropzone,
    ModalCloseButton,
  },
  mixins: [modal],
  store,
  props: {
    gid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      numPages: 1,
      actualPage: 1,
      personId: "",
      dropzoneOptions: dropzoneOptionsBild(Api.defaults.baseURL, this.gid),
    };
  },
  created() {},
  computed: {},
  methods: {
    close() {
      $("#bild-modal").modal("hide");
    },
    uploadFiles() {
      this.$refs.dokumenteUpload.processQueue();
    },
    fileUploaded() {
      $("#bild-modal").modal("hide");
      this.$emit("bildUploaded");
      //this.$parent.getDokumente(true);
    },
    closeModal() {
      this.shown = false;
      $("#" + this.id).modal("hide");
    },
  },
};
</script>

<style>
</style>